import React from 'react'
import { Flex, Text, Button, Link } from '@pancakeswap/uikit'
import { useTranslation } from 'contexts/Localization'
import styled, { keyframes } from 'styled-components'
import CompositeImage, { CompositeImageProps } from '../CompositeImage'
import PurpleWordHeading from '../PurpleWordHeading'

interface SalesSectionButton {
  to: string
  text: string
  external: boolean
}

export interface SalesSectionProps {
  headingText: string
  bodyText: string
  reverse: boolean
  primaryButton: SalesSectionButton
  secondaryButton: SalesSectionButton
  images: CompositeImageProps
}

const SalesSection: React.FC<SalesSectionProps> = (props) => {
  const { t } = useTranslation()

  const { headingText, bodyText, reverse, primaryButton, secondaryButton, images } = props

  const headingTranslatedText = t(headingText)
  const bodyTranslatedText = t(bodyText)
 
  const ButtonText = styled(Text)`
  display: none;
  ${({ theme }) => theme.mediaQueries.xs} {
    display: block;
  }
`
  return (
    <Flex flexDirection="column"     alignItems="center"
    >
      <Flex
        alignItems="center"
        justifyContent="center"
      >
        <Flex
          flexDirection="column"
          alignItems="center"
          >
          <PurpleWordHeading text={headingTranslatedText} textAlign="center"/>
          <Text color="textSubtle" mb="24px" textAlign="center">
            {bodyTranslatedText}
          </Text>
          <Flex>
            <Link mr="16px" external={primaryButton.external} href="/mining">
              <Button height="40px" mb="16px" width="100px">
              <ButtonText color="text" bold fontSize="14px">
          {t('LP MINING')}
        </ButtonText>
              </Button>
            </Link>
            <Link  mr="16px"  external={secondaryButton.external} href="/pools/all">
            <Button height="40px" mb="16px" width="120px">
              <ButtonText color="text" bold fontSize="14px">
          {t('STAKING POOLS')}
        </ButtonText>
              </Button>
            </Link>
            <Link external={secondaryButton.external} href="/be2mining/all">
            <Button height="40px" mb="16px" width="100px">
              <ButtonText color="text" bold fontSize="14px">
          {t('BE2MINING')}
        </ButtonText>
              </Button>
            </Link>
          </Flex>
        </Flex>
      </Flex>
    </Flex>
  )
}

export default SalesSection
